import { render, staticRenderFns } from "./AdmissionTypeSelection.vue?vue&type=template&id=68b06216&scoped=true&"
import script from "./AdmissionTypeSelection.vue?vue&type=script&lang=ts&"
export * from "./AdmissionTypeSelection.vue?vue&type=script&lang=ts&"
import style0 from "./AdmissionTypeSelection.vue?vue&type=style&index=0&id=68b06216&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b06216",
  null
  
)

export default component.exports